/**
 * 사이드바 항목 — **배열 하나**다.
 *
 * ⚠️ Flutter 쪽 `AppSidebar` 는 1,677줄이다. FF 가 항목마다 위젯 트리를
 * 복제했기 때문이고, 내용은 이 표와 같다(`dsl/edit.dart` `_navPrimary` ·
 * `_navExplore` · `_navPhase2`).
 */

export interface NavItem {
  label: string;
  key: string;
  /** 비면 Phase 2 — 메뉴에 실재하되 비활성이다. */
  path: string | null;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

/**
 * ★ 경로는 현재 Flutter 앱과 **같은 이름**으로 잡는다 — 배포를 갈아탈 때
 *   북마크와 SORO 딥링크가 그대로 살아야 한다.
 */
export const NAV: NavSection[] = [
  {
    title: '핵심 지표',
    items: [
      { label: '개요', key: 'home', path: '/' },
      { label: '완주율', key: 'completion', path: '/completion' },
      { label: '진행 불가', key: 'blocked', path: '/blocked' },
      { label: 'AI 오서술', key: 'narration', path: '/narrationQa' },
      { label: '회차당 원가', key: 'cost', path: '/cost' },
    ],
  },
  {
    title: '탐색',
    items: [
      { label: '회차', key: 'runs', path: '/runList' },
      { label: '장면', key: 'scenes', path: '/sceneList' },
      { label: '설정', key: 'settings', path: '/settings' },
    ],
  },
  {
    // ★ 자리를 미리 잡아 정보 구조를 고정한다 — 비활성이지만 메뉴에 실재한다.
    title: 'Phase 2',
    items: [
      { label: '리텐션', key: 'engagement', path: null },
      { label: 'AI 품질 심층', key: 'aiQuality', path: null },
      { label: '버전 비교', key: 'versionCompare', path: null },
      { label: '운영 모니터링', key: 'opsMonitor', path: null },
      { label: 'SORO 브릿지', key: 'soro', path: null },
    ],
  },
];

/** 기간 칩. ⚠️ 키는 `dsl/edit.dart` `_rangeChip` 과 **같아야 한다**. */
export const RANGES: Array<{ label: string; key: string }> = [
  { label: '오늘', key: '24h' },
  { label: '7일', key: '7d' },
  { label: '30일', key: '30d' },
  { label: '전체', key: 'all' },
];
